import { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, TableSortLabel, TableCell, TableHead, TableRow, Checkbox, Grid, } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { deleteContributionApi, getContributionApi } from '../apiService';
import { useParams } from 'react-router-dom';
import { checkApiStatus } from '../../../../utils';
import ShowAttachments from '../../../../shared_elements/components/ShowAttachments';
import { PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { enqueueSnackbar } from 'notistack';
import { ContributionCRU, ContributionList } from '../components';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { ButtonLoader } from '../../../../shared_elements/components';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const ContributionHd = ({ sortInfo, createSortHandler, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Contributions`, page_type: page_type, })
    }
    const tableSorting = (key, name) => (
        <TableSortLabel
            disabled={key === "lessee" || key === "lessor"}
            hideSortIcon={key === "lessee" || key === "lessor"}
            sx={{ whiteSpace: "nowrap" }}
            active={sortInfo?.sort_by === key}
            direction={sortInfo?.sort_by === key ? sortInfo.sort : 'asc'}
            onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
        >
            {name}
        </TableSortLabel>
    );

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "contribution", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell>{tableSorting("component", "Component")}</TableCell>
                <TableCell>{tableSorting("party", "Party")}</TableCell>
                <TableCell>{tableSorting("type", "Type")}</TableCell>
                <TableCell>{tableSorting("event", "Event")}</TableCell>
                <TableCell>{tableSorting("partly_estimated", "Partly Estimated")}</TableCell>
                <TableCell>{tableSorting("estimated_occurrence", "Estimated Occurrence")}</TableCell>
                <TableCell>{tableSorting("completed", "Completed")}</TableCell>
                <TableCell>{tableSorting("reference", "Reference")}</TableCell>
                <TableCell>{tableSorting("description", "Description")}</TableCell>
            </TableRow>
        </TableHead>
    );
};

const Contributions = () => {
    const params = useParams();
    const dispatch = useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [contributionInfo, setContributionInfo] = useState({ list: [], pagination: {} });
    const [addEditContribution, setAddEditContribution] = useState({ mode: '', modal: false, data: null });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
    const [deleteContribution, setDeleteContribution] = useState({ modal: false, data: null, })
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})



    useEffect(() => {
       const uploadedFileData = getApiResponse("Parties", slug);
        getContributionList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'Contributions'})
        setUploadFileProgressData({uploadedFileData});
    }, []);

    const getContributionList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getContributionApi(params, query))
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus(response)) {
                    setContributionInfo(response.data.data);
                }
            });
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"contribution"}))
    };


    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditContribution?.modal) {
            setAddEditContribution({
                ...addEditContribution,
                data: {
                    ...addEditContribution.data,
                    attachments: addEditContribution.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getContributionList('', { per_page: contributionInfo?.pagination?.per_page || 50 });
    }


    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getContributionList('', { ...sortQuery, per_page: contributionInfo?.pagination?.per_page });
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const deleteContributionFn = () => {
        setLoading(true);
        const idsToDelete = deleteContribution?.modal && deleteContribution?.data?.id ? [deleteContribution?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteContributionApi(params), { ids: idsToDelete } )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Contribution`, success_msg: response?.data?.message, item_ids: deleteContribution?.data || bulk?.ids, response: response?.data })
                    setDeleteContribution({ modal: false, data: null });
                    getContributionList('fetch', { per_page: contributionInfo?.pagination?.per_page || 50 });
                    setBulk({ modal: false, ids: [], wrkGrpSlug: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Contribution`, error_msg: response?.data?.message, item_ids: deleteContribution?.data || bulk?.ids, response: response?.data })
                }
            })
    }
   
    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getContributionApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Contributions`, page_type: page_type, })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "contribution",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
                setUploadFileProgressData({ progressRefs, attachments,response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getContributionList("", { per_page: contributionInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(err?.message || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    };

    return (
        <>
        <LeasesBasicDetails/>
          <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
            <LeasesNav type="technical"/>
            <div className='lease-details-content contnet-overflow'>
                <Paper square className="responsive-paper">
                    <Grid container className="responsive-grid" alignItems='flex-end'>
                        <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                            <LeasesMenuList btnText="Contributions" type="technical"/>
                        </Grid>
                        <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                        </Grid>
                        <Grid item size={{ md: 6, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                {
                                    bulk?.type && bulk?.ids?.length ?
                                        <>
                                            <li className='lease-mobile-button'>
                                                <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                            </li>
                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "contribution",operationType: ['D'] }}>
                                                <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                                </li>
                                            </PermissionWrapper>
                                        </> : null
                                }
                                {contributionInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button>  </li> : null}
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "contribution", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button variant="contained" color="primary" size='small' startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' onClick={() => { setAddEditContribution({ modal: true, data: { component: "", event: "", party: "", type: "", reference: "", completed: "", partly_estimated: "", estimated_occurence: "", description: "" }, mode: 'add' }); handleItemClicked('Add Item Button') }}> Add Contribution </Button> </li>
                                    </PermissionWrapper>
                            </ul>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: contributionInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                            <Table className="mui-table-format" stickyHeader>
                                <ContributionHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={contributionInfo?.list} toggleBulkOps={toggleBulkOps} />
                                <TableBody>
                                    {contributionInfo?.list?.length > 0 && contributionInfo?.list?.map((item, index) => {
                                         const uploadedFileData = getApiResponse("contribution", item?.slug);

                                        return (
                                            <ContributionList
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData }
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onEditFn={() => setAddEditContribution({ modal: true, data: item, mode: 'edit' })}
                                                onView={() => setAddEditContribution({ modal: true, data: item, mode: 'view' })}
                                                onDeleteEolFn={() => {
                                                    setDeleteContribution({ modal: true, data: item, });
                                                    setBulk({modal: false, ids: [item], type: ''});
                                                }}
                                                toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                onOpenAttachments={() => setAttachments({ modal: true, data: item })} />
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        )}
                    </div>
                    <Paper square>
                        {!skeletonLoader && !contributionInfo?.list?.length && <NoRecordFound />}
                        <Pagination
                            pagination={contributionInfo?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getContributionList("pageloader", { page: pageNum, per_page: contributionInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getContributionList("pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort, } : {}), }); }}
                        />
                    </Paper>
                </Paper>
            </div>
        </Paper>
            {addEditContribution.modal &&
                <ContributionCRU
                    fileUpload={handleUpload}
                    addEditContribution={addEditContribution}
                    modeType={addEditContribution?.mode}
                    getResponseBack={() => {getContributionList('fetch', { per_page: contributionInfo.pagination.per_page }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onOpenAttachments={() => setAttachments({ modal: true, data: addEditContribution?.data, mode:'view' })}
                    onToggleModal={() => setAddEditContribution({ modal: false, data: null, mode: '' })}
                />
            }
            {deleteContribution.modal &&
                <DeletePopUp
                    modal={deleteContribution.modal}
                    title='Delete Contribution'
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => setDeleteContribution({ modal: false, data: null })}
                    onDeleteRecords={() => deleteContributionFn()}
                />}
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Contribution"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                    onViewDisabled={addEditContribution?.mode === 'view' || attachments?.mode==='view'}
                    permissionKey='contribution'
                /> : null
            }
            {bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk.ids?.length === (contributionInfo?.list?.length || 0) ? "All Contribution" : "Selected Contribution"}`}
                    onDeleteRecords={() => deleteContributionFn()}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [] })}
                /> : null
            }
            {
              revisionHistory.modal &&  
             <RevisionHistory 
              moduleName={"contribution"}
              revisionHistory={revisionHistory}
              onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
            />
            }
            <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />
            {isLoading && <PageLoader />}
        </>
    );
};

export default RoleBaseAccess(Contributions, { application: 'lease_revamp', feature: 'contribution', operationType: ['R'], leaseNav: true });

